import { IconLogoGalaxyBet } from "app/components/Icon/Icon";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import ENV from "../../../../../config";

type AuthScreenSubHeaderProps = {
  setRegistrationModalOpen: () => void;
};

const AuthScreenSubHeader: React.FC<AuthScreenSubHeaderProps> = ({
  setRegistrationModalOpen,
}) => {
  return (
    <div className="auth-screen__sub-header">
      {ENV.CSS_THEME === "GALAXYBET" && <IconLogoGalaxyBet />}
      <h1>
        {ENV.CSS_THEME !== "GALAXYBET" && (
          <FormattedMessage tagName="span" id="home-account-login" />
        )}
        {ENV.CSS_THEME === "GALAXYBET" && (
          <FormattedMessage tagName="span" id="home-member-login" />
        )}
        {ENV.CSS_THEME === "GALAXYBET" && " / 会员登录"}
      </h1>
      {ENV.CSS_THEME === "DEFAULT" && (
        <div className="auth-screen__sub-header__no-account">
          <FormattedMessage tagName="span" id="home-no-account" />
          <div
            className="auth-screen__sub-header__no-account--register"
            onClick={() => {
              setRegistrationModalOpen();
            }}
          >
            <FormattedMessage tagName="span" id="home-account-register" />
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  isRegistrationModalOpen: state.registrationFormModel.isRegistrationModalOpen,
});

function mapDispatchToProps(dispatch) {
  return {
    setRegistrationModalOpen: () => {
      dispatch.registrationFormModel.setRegistrationModalOpen();
    },
    closeRegistrationModal: () => {
      dispatch.registrationFormModel.closeRegistrationModal();
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthScreenSubHeader);
